import { createRouter, createWebHistory } from 'vue-router'
import { EventBus } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	
	routes: [
		{
			path: '/',
			name: 'index',
			component: () => import('../views/Index.vue')
		},
		{
			path: '/estate/:estateID',
			name: 'overview',
			component: () => import('../views/Overview.vue'),
			
			props: $route => ({
				estateID: $route.params.estateID,
				orderID: $route.query.orderid,
				secret: $route.query.secret
			})
		},
		{
			path: '/estate/:estateID/:protocolType',
			name: 'protocol-type',
			component: () => import('../views/ProtocolType.vue'),
			
			props: $route => ({
				estateID: $route.params.estateID,
				orderID: $route.query.orderid,
				protocolType: $route.params.protocolType,
				secret: $route.query.secret
			})
		}
	]
})

router.beforeEach((to, from, next) => {
	EventBus.$emit('beforeRouteChange', to)
	next()
})

router.afterEach((to) => {
	EventBus.$emit('routeChanged', to)
})

export default router
